let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cTfSM")).then(() => parcelRequire('8KVwU'));